import type { CheckboxProps } from './checkbox.types.tsx';
import { Checkbox as KendoCheckbox } from '@progress/kendo-react-inputs';
import styles from './checkbox.module.scss';

export function Checkbox({ label, checked, onChange }: CheckboxProps) {
  return (
    <div className={styles.container}>
      <KendoCheckbox label={label} checked={checked} labelPlacement={'before'} size={'large'} onChange={onChange} />
    </div>
  );
}
